export default __webpack_public_path__ + "static/media/notificationRefresh.91b05c2d.svg";